import SmartImage from "../../../../../components/SmartImage";
import { getLabel } from "../../../../../hooks/use-labels";
import { formatMoney } from "../../../../../features/orders/format";

const itemLabel = (item) => {
  const material = item.material ? ` (${item.material})` : "";
  const fill = item.customFill && item.volume ? ` · ${item.volume}kg` : "";

  return `${item.quantity}x ${item.name}${material}${fill}`;
};

const MoneyRow = ({ label, money, hideWhenEmpty }) => {
  if (hideWhenEmpty && (!money || !money.value)) return null;

  return (
    <div className="ord-receipt-row">
      <span className="ord-receipt-label">{label}</span>
      <span className="ord-receipt-value">{formatMoney(money)}</span>
    </div>
  );
};

const SupplierReceipt = ({
  detail,
  supplier,
  heading,
  badge,
  showPayment = true,
  showTotal = true,
  children,
}) => {
  const logo = supplier?.logoUrl || detail?.supplier?.logoUrl;
  const name = supplier?.name || detail?.supplier?.name;
  const initials = supplier?.initials || detail?.supplier?.initials;

  return (
    <section className="ord-panel ord-receipt">
      {heading && (
        <div className="ord-panel-head">
          <span className="ord-receipt-heading">{heading}</span>

          {badge && (
            <span className={`ord-status ord-status-${badge.tone}`}>
              {badge.label}
            </span>
          )}
        </div>
      )}

      <div className="ord-supplier">
        {logo ? (
          <SmartImage
            src={`${logo}?size=xs`}
            alt=""
            width="38px"
            height="38px"
            radius="10px"
          />
        ) : (
          <span className="ord-avatar ord-avatar-initials">{initials}</span>
        )}

        <span className="ord-supplier-name">{name}</span>
      </div>

      <div className="ord-receipt-items">
        {detail.items.map((item) => (
          <div className="ord-receipt-row" key={item.key}>
            <span className="ord-receipt-label">{itemLabel(item)}</span>
            <span className="ord-receipt-value">{formatMoney(item.amount)}</span>
          </div>
        ))}
      </div>

      <div className="ord-receipt-rule" />

      <div className="ord-receipt-money">
        <MoneyRow label={getLabel("subTotalLabel")} money={detail.money.subTotal} />
        <MoneyRow
          label={getLabel("couponDiscountLabel")}
          money={detail.money.discount}
        />
        <MoneyRow
          label={getLabel("deliveryFeeLabel")}
          money={detail.money.deliveryFee}
        />
        <MoneyRow
          label={getLabel("platformFeeLabel")}
          money={detail.money.platformFee}
        />
        <MoneyRow
          label={`${getLabel("taxOrVATLabel")} Inc.`}
          money={detail.money.tax}
          hideWhenEmpty
        />
        <MoneyRow label="Refunded" money={detail.money.refunded} hideWhenEmpty />
      </div>

      {showPayment && detail.payments.length > 0 && (
        <div className="ord-receipt-money ord-receipt-payments">
          {detail.payments.map((payment, index) => (
            <div key={payment.transactionId ?? index}>
              {payment.transactionId && (
                <div className="ord-receipt-row">
                  <span className="ord-receipt-label">Transaction ID</span>
                  <span className="ord-receipt-value">
                    {payment.transactionId}
                  </span>
                </div>
              )}

              <div className="ord-receipt-row">
                <span className="ord-receipt-label">
                  {getLabel("paymentMethodLabel")}
                </span>
                <span className="ord-receipt-value">{payment.gatewayLabel}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {showPayment && detail.codDue && (
        <p className="ord-cod-note">
          {formatMoney(detail.codDue)} to be paid on delivery
        </p>
      )}

      {showTotal && (
        <div className="ord-receipt-total">
          <span>{getLabel("totalLabel") || "Total"}</span>
          <span>{formatMoney(detail.money.total)}</span>
        </div>
      )}

      {children}
    </section>
  );
};

export default SupplierReceipt;
